import Marquee from "../Marquee";
import { Reveal } from "../Reveal";

const ITEMS = [
  "7 jours",
  "3 grandes soirées",
  "Des expériences entre les rendez-vous",
  "Un groupe privé",
  "Les replays inclus",
];

export default function Banner() {
  return (
    <section
      className="section bg-pearl text-abyss py-14 md:py-20 relative overflow-hidden"
      data-testid="banner-section"
    >
      <Marquee items={ITEMS} />

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-10 md:mt-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-x-6 gap-y-8">
          {ITEMS.map((it, i) => (
            <Reveal key={it} delay={i * 0.06} className="flex flex-col gap-2">
              <span className="chapter-num text-turquoise">{String(i + 1).padStart(2, "0")}</span>
              <span className="font-display text-xl md:text-2xl leading-tight text-abyss">
                {it}
              </span>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-12 pt-8 border-t border-abyss/10">
          <p className="font-display italic text-2xl md:text-3xl text-abyss/80">
            Une expérience offerte, vécue sur engagement.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
